import { FiReportPieChartModule } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart.module';
import { FiReportWidgetModule } from './fi-report-widget/fi-report-widget.module';
import { FiSimpleContenteditableModule } from './fi-simple-contenteditable/fi-simple-contenteditable.module';
import { FiEditorPageHeaderModule } from './fi-editor-page-header/fi-editor-page-header.module';
import { FiProfileIconStackedModule } from './fi-profile-icon-stacked/fi-profile-icon-stacked.module';
import { FiCustomEmailModule } from './fi-custom-email-validator/fi-custom-email.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageService } from '../utilities/fi-services/error-message.service';
import { ObjectTypesService } from '../utilities/fi-services/object-types.service';
import { AppTextService, FiAppTextSharedModule } from '@fi-shared/app-text';
import { RelativeDateService } from './relative-date/relative-date.service';
import { FiSharedWidgetModule } from './widget/widget.module';
import { FiLoadingModule } from './fi-loading/fi-loading.module';
import { FiLocaleService } from './fi-locale.service';
import { FiPasswordChangeModule } from '@fi-shared/fi-password-change/fi-password-change.module';
import { FiContenteditableModule } from '@fi-shared/fi-contenteditable/fi-contenteditable.module';
import { FiContentLanguageSharedModule } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.module';
import { FiMediaBankSharedModule } from '@fi-shared/media-bank/media-bank.module';
import { FiSignalRModule } from '@fi-shared/fi-signal-r/fi-signal-r.module';
import { FiMediaViewerModule } from '@fi-shared/media-viewer/media-viewer.module';
import { FiDialogsGenericModule } from '@fi-shared/fi-dialogs-generic/fi-dialogs-generic.module';
import { FiStateProxyModule } from '@fi-shared/fi-state-proxy/fi-state-proxy.module';
import { FiCommentsModule } from '@fi-shared/fi-comments/fi-comments.module';
import { FiChartModule } from '@fi-shared/fi-chart/fi-chart.module';
import { PipesModule } from '@fi-shared/fi-pipes/pipes.module';
import { FiBackendSharedModule } from '@fi-shared/fi-backend/fi-backend.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiForumModule } from '@fi-shared/fi-forum/fi-forum.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { StatisticModule } from '@fi-shared/statistic/statistic.module';
import { FiChatModule } from '@fi-shared/fi-chat/fi-chat.module';
import { FiNotificationSharedModule } from '@fi-shared/fi-notification/fi-notification-shared.module';
import { FiEmojiModule } from '@fi-shared/fi-emoji-button/fi-emoji.module';
import { FiEmojiService } from '@fi-shared/fi-emoji-button/fi-emoji.service';
import { FiGiphyModule } from '@fi-shared/fi-giphy/fi-giphy.module';
import { FiEmojiMartOverlayModule } from '@fi-shared/fi-emoji-mart-overlay/fi-emoji-mart-overlay.module';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { FiUsersListRelatedToObjectTypeModule } from '@fi-shared/fi-users-list-related-to-object-type/fi-users-list-related-to-object-type.module';
import { FiSupportModule } from '@fi-shared/fi-support/fi-support.module';
import { FiChecklist2Module } from '@fi-shared/checklist/fi-checklist2.module';
import { FiSectionCardModule } from '@fi-shared/fi-section-card/fi-section-card.module';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiTextItemHelperModule } from '@fi-shared/fi-text-item-helper/fi-text-item-helper.module';
import { FiObjectEditorInfoModule } from '@fi-shared/fi-object-editor-info/fi-object-editor-info.module';
import { FiUserSharedModule } from '@fi-shared/fi-user-shared/fi-user-shared.module';
import { FiColorPalettePickerModule } from '@fi-shared/fi-color-palette-picker/fi-color-palette-picker.module';
import { FiEditObjectDialogModule } from '@fi-shared/fi-edit-object-dialog/fi-edit-object-dialog.module';
import { FiMenuMultiSelectItemSearchModule } from '@fi-shared/fi-menu-multi-select-item-search/fi-menu-multi-select-item-search.module';
import { FiAuthSharedModule } from '@fi-shared/fi-auth-shared/fi-auth-shared.module';
import { FiRelativeDateModule } from '@fi-shared/relative-date/relative-date.module';
import { FiTranslationRadioGroupModule } from '@fi-shared/fi-translation-radio-group/fi-translation-radio-group.module';
import { FiDateTimePickerDialogModule } from '@fi-shared/fi-date-time-picker-dialog/fi-date-time-picker-dialog.module';
import { FiCircularGradientProgressBarModule } from '@fi-shared/fi-circular-gradient-progress-bar/fi-circular-gradient-progress-bar.module';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { FiMatTabGroupBookmarkLayoutModule } from '@fi-shared/fi-mat-card-bookmark-layout/fi-mat-tab-group-bookmark-layout.module';
import { FiAutocompleteItemsModule } from '@fi-shared/fi-autocomplete-items/fi-autocomplete-items.module';
import { FiUserContactChipGridInputModule } from '@fi-shared/fi-user-contact-chip-grid-input/fi-user-contact-chip-grid-input.module';
import { FiInputNumberFractionModule } from '@fi-shared/fi-input-number-fraction/fi-input-number-fraction.module';
import { FiGradientTimerModule } from '@fi-shared/fi-gradient-timer/fi-gradient-timer.module';
import { FiGradientCircleModule } from '@fi-shared/fi-gradient-circle/fi-gradient-circle.module';
import { FiTextPanelModule } from '@fi-shared/fi-text-panel/fi-text-panel.module';
import { FiTextEditorModule } from '@fi-shared/text-editor/text-editor.module';
import { OperationOverlaySmallModule } from '@fi-shared/operation-overlay-small/operation-overlay-small.module';
import { FiDirectivesModule } from '@fi-shared/fi-directives/fi-directives.module';
import { FiMenuFoldableMultiSelectItemSearchModule } from '@fi-shared/fi-menu-foldable-multi-select-item-search/fi-menu-foldable-multi-select-item-search.module';
import { FiTimeAgoPipeModule } from '@fi-shared/fi-time-ago-pipe/fi-time-age.module';
import { FiContactsModule } from '@fi-shared/fi-contacts/fi-contacts.module';
import { FiPasswordValidationProgressModule } from '@fi-shared/password-validation-progress/password-validation-progress.module';
import { FiSetPasswordModule } from '@fi-shared/set-password/set-password.module';
import { FiTimePickerInputModule } from '@fi-shared/fi-time-picker-input/fi-time-picker-input.module';
import { FiThreeColumnsContainerModule } from '@fi-shared/fi-three-columns-container/fi-three-columns-container.module';
import { FiConnectedDropdownItemsModule } from '@fi-shared/fi-connected-dropdown-items/fi-connected-dropdown-items.module';
import { FiConfirmUserDeleteDialogComponentModule } from '@fi-shared/fi-confirm-user-delete-dialog/fi-confirm-user-delete-dialog.component.module';
import { FiDotLoaderModule } from '@fi-shared/fi-dot-loader/fi-dot-loader.module';
import { FiInfoBannerModule } from '@fi-shared/fi-info-banner/fi-info-banner.module';
import { FiManualSharingSelectionInfoContainerModule } from '@fi-shared/fi-manual-sharing-selection-info-container/fi-manual-sharing-selection-info-container.module';
import { TaskEditTaskAssigneeModule } from '@fi-shared/fi-task-shared/task-edit-task-assignee/task-edit-task-assignee.module';
import { FiNameDescriptionInputModule } from './name-description-input/name-description-input.module';
import { FiAutomatedActionRecipientSelectModule } from './automated-action-recipient-select/automated-action-recipient-select.module';
import { FiAutomatedActionListItemModule } from './automated-action-list-item/action-list-item.module';
import { FiSectionsDndEditorModule } from './fi-sections-dnd-editor/fi-sections-dnd-editor.module';
import { FiAnswerOptionsDndEditorModule } from './fi-answer-options-dnd-editor/fi-answer-options-dnd-editor.module';
import { FiProgressBadgeModule } from './fi-progress-badge/fi-progress-badge.module';
import { FiExpandableTextDirectiveModule } from './fi-expandable-text-directive/fi-expandable-text-directive.module';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';
/**
 * Module with common components and services for mobile app and desktop
 */
@NgModule({
    imports: [
        CommonModule,
        FiSharedWidgetModule,
        FiLoadingModule,
        FiBackendSharedModule,
        FiChartModule,
        FiPasswordChangeModule,
        FiCustomEmailModule,
        FiContenteditableModule,
        FiContentLanguageSharedModule,
        FiMediaBankSharedModule,
        FiMediaViewerModule,
        FiSignalRModule,
        FiDialogsGenericModule,
        FiStateProxyModule,
        FiCommentsModule,
        FiLocalSearch2Module,
        FiDirectivesModule,
        FiForumModule,
        FiItemsListModule,
        FiChatModule,
        StatisticModule,
        FiNotificationSharedModule,
        PipesModule,
        FiGiphyModule,
        FiEmojiModule,
        FiEmojiMartOverlayModule,
        FiTwoColumnsContainerModule,
        FiToggleSwitchModule,
        FiUsersListRelatedToObjectTypeModule,
        FiSupportModule,
        FiTextItemHelperModule,
        FiChecklist2Module,
        FiSectionCardModule,
        FiIconTooltipButtonModule,
        FiObjectEditorInfoModule,
        FiUserSharedModule,
        FiAuthSharedModule,
        FiRelativeDateModule,
        FiColorPalettePickerModule,
        FiMenuMultiSelectItemSearchModule,
        FiTranslationRadioGroupModule,
        FiDateTimePickerDialogModule,
        FiCircularGradientProgressBarModule,
        FiMatIconCheckboxMenuModule,
        FiMatTabGroupBookmarkLayoutModule,
        FiAutocompleteItemsModule,
        FiUserContactChipGridInputModule,
        FiInputNumberFractionModule,
        FiGradientTimerModule,
        FiGradientCircleModule,
        FiTextPanelModule,
        FiTextEditorModule,
        OperationOverlaySmallModule,
        FiMenuFoldableMultiSelectItemSearchModule,
        FiTimeAgoPipeModule,
        FiContactsModule,
        FiPasswordValidationProgressModule,
        FiSetPasswordModule,
        FiTimePickerInputModule,
        FiThreeColumnsContainerModule,
        FiConnectedDropdownItemsModule,
        FiConfirmUserDeleteDialogComponentModule,
        FiDotLoaderModule,
        FiInfoBannerModule,
        FiManualSharingSelectionInfoContainerModule,
        FiProfileIconStackedModule,
        FiEditorPageHeaderModule,
        FiSimpleContenteditableModule,
        TaskEditTaskAssigneeModule,
        FiReportWidgetModule,
        FiReportPieChartModule,
        FiNameDescriptionInputModule,
        FiAutomatedActionRecipientSelectModule,
        FiAutomatedActionListItemModule,
        FiSectionsDndEditorModule,
        FiAnswerOptionsDndEditorModule,
        FiProgressBadgeModule,
        FiExpandableTextDirectiveModule,
        FiNameInputModule,
    ],
    providers: [
        ErrorMessageService,
        ObjectTypesService,
        AppTextService,
        RelativeDateService,
        FiLocaleService,
        FiEmojiService,
    ],
    exports: [
        FiSharedWidgetModule,
        FiLoadingModule,
        FiChartModule,
        FiPasswordChangeModule,
        FiCustomEmailModule,
        FiMediaViewerModule,
        FiStateProxyModule,
        FiCommentsModule,
        FiDirectivesModule,
        FiTwoColumnsContainerModule,
        FiUsersListRelatedToObjectTypeModule,
        FiChecklist2Module,
        FiSectionCardModule,
        FiIconTooltipButtonModule,
        FiEditObjectDialogModule,
        FiRelativeDateModule,
        FiColorPalettePickerModule,
        FiMenuMultiSelectItemSearchModule,
        FiTranslationRadioGroupModule,
        FiDateTimePickerDialogModule,
        FiCircularGradientProgressBarModule,
        FiMatIconCheckboxMenuModule,
        FiMatTabGroupBookmarkLayoutModule,
        FiAutocompleteItemsModule,
        FiUserContactChipGridInputModule,
        FiInputNumberFractionModule,
        FiGradientTimerModule,
        FiGradientCircleModule,
        FiTextPanelModule,
        FiTextEditorModule,
        OperationOverlaySmallModule,
        FiMenuFoldableMultiSelectItemSearchModule,
        FiTimeAgoPipeModule,
        FiPasswordValidationProgressModule,
        FiSetPasswordModule,
        FiTimePickerInputModule,
        FiThreeColumnsContainerModule,
        FiConnectedDropdownItemsModule,
        FiConfirmUserDeleteDialogComponentModule,
        FiDotLoaderModule,
        FiInfoBannerModule,
        FiManualSharingSelectionInfoContainerModule,
        FiEditorPageHeaderModule,
        FiSimpleContenteditableModule,
        TaskEditTaskAssigneeModule,
        FiReportWidgetModule,
        FiReportPieChartModule,
        FiNameDescriptionInputModule,
        FiAutomatedActionRecipientSelectModule,
        FiSectionsDndEditorModule,
        FiAnswerOptionsDndEditorModule,
        FiProgressBadgeModule,
        FiExpandableTextDirectiveModule,
    ],
})
export class SharedModule {}
